export default {
  App: {
    title: {
      notfound: '404 Not Found.',
      loading: 'Global Ordering Portal',
      login: 'Login - iFi Audio',
      streamqrcode: 'iFi Stream app - iFi Audio',
      gaiaapp: 'iFi Gaia app - iFi Audio',
      nexisapp: 'iFi Nexis app - iFi Audio',
      home: 'Global Ordering Portal',
      details: 'Details - iFi Audio',
      cart: 'Shopping Cart - iFi Audio',
      orderconfirm: 'Confirm - iFi Audio',
      orderform: 'Order infomation - iFi Audio',
      console: 'Dashboard - iFi Audio',
      center: 'Personal center - iFi Audio',
    },
    notify: {
      title_success: 'Success',
      title_server: 'Server',
      content_server: 'Server time out caused by: ',
      content_servererr: 'Bad network, request was rejected(Code: 10007)',
      content_k3error:
        'K3 system throws exception, please contact your administrator',
      conten_k3err_dts: 'The configuration of K3 system throws an exception: ',
      content_k3exchangeerr:
        'Exchange rate of k3 system is out of date, contact your finance to update it',
      content_carterr:
        'Shopping cart throws exception, please contact your administrator',
      title_retry: 'Retry',
      content_loginerr: 'Incorrect username or password',
      title_nofity: 'Notification',
      content_testversion:
        'Welcome to login, all service was loaded completely',
      title_warning: 'Warning',
      content_illegal: 'Illegal operation',
      content_illegal_params: 'Illegal params.',
      title_err: 'Error',
      content_unknownerr: 'Unknow Error',
      content_user_disabled: 'No Access.',
      content_noresult: 'No results.',
      content_redudancy:
        'Please contact with administrator to confirm your order.',
      content_entitiesept:
        'Service for resource down, please contact administrator.',
      content_no_item: 'No data.',
      content_no_tracking: 'No more tracking infomation.',
      content_jpgonly: 'jpg/png only are allowed.',
      content_uploadlmt: 'Size is out of limit.',
      span_no_notification: 'No Older Notifications',
      content_optsuccess: 'Success',
      content_country_null:
        'Unable to get countries, close website and login later',
      content_redundancy: 'Request has any error, contact your administrator!',
      notice_auto_logist_err:
        ' Please choose a logistics company manually if your tracking number is not found.',
      notification_neworder_title: 'New order',
      notification_neworder_body:
        'You have a new order on iFi ordering portal.',
      init_notification_title: 'iFi ordering portal',
      init_notification_body: 'Order notifications are enable!',
      loginviadingtalk: 'Login via Dingtalk.',
      ntf_uptodate: 'It is up to date.',
      loginviapass: 'Login via Dingtalk to enjoy the best experience.',
      vpn_network_err: 'Make sure your network and VPN are both working.',
      wbstore_saleorg:
        "'AL' is the default sale organization and uses the 'Standard order on 3PL.'",
      spstore_saleorg:
        "'AGL' is the default sale organization and uses the 'Standard order on 3PL.'",
      msg_required: 'All columns are required.',
      refresh: 'Data has been updated, please refresh the page.',
      notify_exist: 'Data already exists',
    },
    verify: {
      username_required: 'Username is required.',
      username_length: 'Username should between 2 and 15 characters.',
      password_required: 'Password is required.',
      password_length: 'Password should between 3 and 15 characters.',
    },
    text: {
      placeholder: 'Input...',
      placeholder_tag_shippingadd: 'Such as: Home, Company',
      placeholder_notes: 'Comments: ',
      placeholder_select: 'Select...',
      placeholder_search: 'Search...',
      phd_username: 'Username',
      phd_password: 'Password',
      username: 'Username',
      password: 'Password',
      dologin: 'Login',
      loading: 'loading...',
      search: 'Search',
      done: 'Save',
      cancel: 'Cancel',
      update: 'Update',
      login_alert:
        'Use Chrome, Safari, Firefox, Opera, Edge to enjoy the best experience.',
      ikonw: 'Got it.',
      usd_abbr: 'USD',
      rmb_abbr: 'CNY',
      kg_abbr: 'Kg',
      submit: 'Submit',
      start_date: 'Start Date',
      end_date: 'End Date',
      range_separator: 'To',
      last_a_week: 'Last a week',
      last_a_month: 'Last a month',
      last_three_months: 'Last 3 months',
      score: 'Score',
      hi: 'Hi, ',
      'utc+8': 'UTC+8',
      not_bound: 'Not Bound',
      save: 'Done',
      month: 'month(s)',
      out_of_sale: 'Out of sale product',
      yes: 'Yes',
      no: 'No',
      beta: 'Beta',
      checkall: 'Check All',
      load_info: 'Loading information...',
      copy_success: 'Copied',
      clicktocopy: 'Click to copy',
      wb_statuses: 'Statuses: ',
      wb_downloaded: 'Downloaded',
      wb_checked: 'Checked',
      wb_callbacked: 'Callbacked',
      wb_arrived: 'Arrived',
      s_fulfilled: 'Fulfilled',
      wb_canceled: 'Canceled',
      wb_refunded: 'Refunded',
      wb_followed: 'Followed',
      txt_enabled: 'Enabled',
      text_disabled: 'Disabled',
      txt_deactivated: 'Deactivated',
      edit: 'Edit',
      push: "Push"
    },
    tabs: {
      international_customer: 'International customer',
      domestic_customer: 'Chinese customer',
      international_order: 'International order',
      domestic_order: 'Chinese order',
      quickordering: 'Quick ordering',
      'w-order': 'Webstore order',
      shopify: 'Shopify(iFi site)',
      globalemail: 'Email notification',
      synproducts: 'Product',
      pricingrules: 'Pricing rule',
      discountrules: 'Discounted rule',
      pricesystem: 'Master Pack Price Config',
      standardorder: 'Standard order',
      webstoreorder: 'eCommerce order',
      country: 'Region',
      payment: 'Payment',
      currency: 'Currency',
      orderstatus: 'Order status',
      brand: 'Brand',
      satisfacationsurvey: 'Survey',
      serialnumbertool: 'SN tool',
      analysis: 'Analysis',
      mysetting: 'Setting',
      shopifyorder: 'Shopify Order',
    },
    view: {
      custCommonHead: {
        router_logout: 'Logout',
        router_custhome: 'Information',
        router_cart: 'Shopping Cart',
        head_notice:
          '温馨提示：中国春节期间（1月27日-2月10日），订单处理可能会出现延迟，请您提前安排好您的订单计划，不便之处敬请谅解！',
      },
      consolesetting: {
        title_basic: 'Basic',
        title_dingtalk: 'Dingtalk',
        title_k3: 'K3',
        label_username: 'Username',
        label_sex: 'Gender',
        label_tel: 'Phone number',
        label_email: 'Email',
        label_name: 'Name',
        label_alias: 'English name',
        label_dingtalk_userid: 'Dingtalk ID',
        label_dingtalk_staffname: 'Dingtalk name',
        label_k3_account: 'K3 account',
        label_k3_pass: 'K3 password',
        label_k3_salesid: 'K3 saler id',
        notify_info_null: 'All items are required.',
        resetpass: 'Reset password',
        notify_sales_err: 'Sales information requested failed.',
        text_saveinfo_title: 'Message',
        text_saveinfo_body: 'Really to save?',
      },
      customer: {
        tab_customer: 'Customer',
        btn_synchronize: 'Synchronize',
        btn_register: 'Create',
        empty_customer: "Click 'Synchronize' to update.",
        label_username: 'Username',
        label_name: 'Full name',
        label_alias: 'Alias',
        label_paymentterms: 'Payment term',
        label_country: 'Region',
        label_discount: 'Discount(0~1)',
        label_minweight: 'The minimum weight',
        label_minamount: 'The minimum amount',
        label_k3id: 'K3 Code',
        label_password: 'Password',
        label_sex: 'Gender',
        label_tel: 'Tel.',
        label_email: 'Email',
        label_type: 'User type',
        label_general: 'General',
        label_brand: 'Brand Range',
        label_ifi: 'iFi',
        label_sl: 'Silent Power',
        label_allb: 'iFi&Silent Power',
        label_mo: 'Maketing Order User',
        label_shippingaddress: 'Shipping address',
        label_invoiceaddress: 'Invoice address',
        label_status: 'Status',
        label_options: 'Option',
        tooltip_username:
          "Username can't be modified when it was registered, use english letter, number and must between 2,15 characters",
        tooltip_name: "Customer's full name",
        tooltip_alias: "Customer's alias",
        tooltip_currency: 'Choose a currency',
        tooltip_paymentterms: 'Choose a payment term',
        tooltip_country: 'Choose region',
        tooltip_discount: 'Set discount',
        tooltip_minweight: 'Set the minimum weight',
        tooltip_minamount: 'Set the minimum amount',
        tooltip_k3id: 'Bound code in K3',
        tooltip_password: 'Password must be between 3,15 characters',
        tooltip_sex: 'Choose gender',
        tooltip_tel: 'Set telephone',
        tooltip_email: 'Set email for pushing notification',
        title_modifycust: "'s infomation",
        label_male: 'Male',
        label_female: 'Female',
        notify_countrysession_err_code: 'Error code: -17',
        notify_countrysession_err:
          'Failed to get region, try to login again or contact your administrator if this problem still exist.',
        button_doedit: 'Save',
        button_doregister: 'Register now',
        button_docancel: 'Cancel',
        message_success: 'Saved',
        register_dialog_title: 'Create customer',
        notify_normal_err_code: 'Error code: -1',
        notify_username_length: 'Username must be between 2,15 characters',
        notify_password_length: 'Password must be between 3,15 characters',
        notify_register_null: 'Register infomation Incomplete',
        notify_address_null: 'Information Incomplete.',
        notify_username_repeatly: 'Username already exists',
        span_username_repeatly: 'Username already exists',
        notify_username_repeatly_err_code: 'Error code: -105',
        notify_username_repeatly_tryagain:
          'Username already exists, refresh or re-login system now',

        notify_email_error: 'The email is not available',
        shipping_dialog_title: 'Shipping address',
        receipt_dialog_title: 'Invoice address',
        delete_address_success: 'Deleted',
        message_cancel: 'Canceled',
        btn_message_confirm: 'Confirm',
        btn_message_cancel: 'No, cancel',
        text_delete_message_body: 'Would you want to delete it?',
        text_delete_message_title: 'Please confirm',
        notify_title_notification: 'Notification',
        notify_full_address: 'Ten addresses per user',
        notify_warn: 'Warning',
        notify_full_address_java:
          "Ten addresses per user! Don't add it illegally!",
        notice_delete_user:
          ' No privilege level to delete customer, contact administrator to authorize.',
        title_add_address: 'Add an address',
        title_edit_address: 'Address Update',
        label_company: 'Company',
        label_contacts: 'Contact',
        label_province: 'Province/State',
        label_city: 'City',
        label_zipcode: 'Zipcode',
        label_address: 'Address',
        label_add_tel: 'Tel.',
        label_add_email: 'Email',
        label_tag: 'Tag',
        label_taxno: 'VAT NO.',
        btn_save: 'Save',
        empty_address: "Nothing here ~~ Click ' + ' to create one",
        notify_least_over1:
          'The minimum weight and amount need greater than 0.',
      },
      order: {
        radio_orderlist_all: 'All',
        radio_orderlist_processing: 'To be determined',
        radio_orderlist_finished: 'Completed',
        radio_orderlist_mo: 'MO',
        label_order_number: 'Entity:',
        label_order_createtime: 'Created time:',
        label_order_proccessing: 'Unfinished',
        label_group_title_basic: 'Basic',
        label_group_title_shipping: 'Shipping',
        label_group_title_receipt: 'Proforma invoice',
        label_group_title_payment: 'Payment',
        label_group_title_document: 'Shipping documents',
        label_group_title_details: 'Details',
        label_group_title_delivery: 'Fulfill',
        label_group_title_list: 'List',
        label_orderstatus: 'Order status:',
        label_orderstatus_next: 'Next status:',
        label_orderid: 'Entity:',
        label_orderfid: 'K3 Order No.:',
        label_custpo: 'Cust PO NO.:',
        label_delivery: 'Delivery term:',
        label_org: 'Sale org.:',
        label_contacts: 'Contact:',
        label_company: 'Company:',
        label_address: 'Address:',
        label_province: 'Province/State:',
        label_city: 'City:',
        label_zipcode: 'Zipcode:',
        label_country: 'Region:',
        label_tel: 'Tel.:',
        label_email: 'Email:',
        label_taxno: 'VAT No.:',
        tooltip_editdelivery: 'Click to reset delivery term',
        span_upload_receipt: 'Upload proforma invoice',
        span_no_payment: 'No Bankslip yet, or you has been skipped this step.',
        span_upload_packinglist: 'Upload packing list',
        span_upload_commercial: 'Upload commercial invoice',
        label_remark: 'Notes/Remark:',
        btn_addition_product: 'Add to details',
        placeholder_addition: 'Input K3 code',
        notify_addition_willdo:
          'This product is found, please confirm to add it to the order list with no discount, the total amount is updated automatically. confirm or not?',
        notify_addition_notfound:
          'Sorry, the code in K3 is not found, please check.',
        notify_addition_success:
          'Success, page will reload after 1s.(no discount and 1pc)',
        productimage: 'Image',
        productname: 'Name',
        productprice: 'Retail Price',
        productdiscount: 'Discount(%)',
        productdisprice: 'Discounted price',
        productquantity: 'Quantity',
        productsubweight: 'Weight(Kg)',
        productsubprice: 'Subtotal',
        label_options: 'Option',
        total_product: 'Total of product:',
        total_quantity: 'Total of quantity:',
        weight_total: 'Weight:',
        order_total: 'Total:',
        order_weight: 'Weight:',
        btn_refresh_order: 'Refresh',
        btn_set_org: 'Re-set organization',
        btn_order_checkedup: 'Check up',
        btn_order_recall: 'Recall',
        btn_files_manage: 'Check files',
        btn_closeorder: 'Close',
        btn_cancalorder: 'Cancel',
        popover_orderrecord: 'Need to check history?',
        text_pickupbyseller: 'Buyer will pick up goods later.',
        label_logistics_no: 'Logistics No.:',
        label_logistics_company: 'Carrier:',
        label_products_batch: 'Products:',
        label_table_prodname: 'Name',
        label_table_prodquantity: 'Quantity',
        btn_savebatchprod: 'Save',
        text_not_select_order: 'Select an order to view details.',
        notify_k3order_success: 'Synchronized to K3 system successfully!',
        notify_upload_success: 'Upload successful',
        btn_upload: 'Upload',
        text_docheckorder_message_title: 'Message',
        text_docheckorder_message_body:
          'Would you like to push this order to K3 system?',
        text_cancelorder_message_body:
          'The order will be removed from the order list after cancellation,  please be cautious before delete! If the order needs to be removed from K3 system, please operate manually!',
        text_recallorder_message_body:
          'Do you want to recall this order, status in K3 will not be changed, continue?',
        text_closeorder_message_body:
          'You will close this order, order will be completed and customer will not receive notification.',
        message_cancel: 'Canceled',
        btn_message_confirm: 'Confirm',
        btn_message_cancel: 'No, cancel',
        btn_proformainvoice_nextstep: 'Done',
        notify_enterproformainvoice_success: 'Proforma invoice confirmed',
        notify_skipto_step4_monthly:
          "Already skip to 'upload bank slip' beacause of monthly payment.",
        link_modify: 'Update',
        span_monthly_payment:
          'No bank slip infomation bacause this customer is monthly payment.',
        btn_skip: 'Skip this step',
        text_skipbankslip_message_body: 'Are you sure to skip this step?',
        notify_skipbankslip_success: 'Skip it successfully!',
        btn_confirm: 'Confirm',
        notify_confirm_banslip_success: 'Confirm successful',
        text_confirmbankslip_message_body:
          'Would you want to confirm the bank slip?',
        btn_update_k3_deliveryorder: 'Update delivery order',
        btn_delivery_start: 'Fill delivery form',
        btn_sign: 'Confirm',
        tag_noticemodifydetails:
          ' Notice: Check it carefully when quantity or discount changed!',
        tag_notice_checkedup_modify:
          ' Notice: Please update information on K3 if you update the details after checked up.',
        text_delivery_message_body:
          'Would you want to deliver this order? This operation is irreversible!',
        text_delivert_message_title: 'Warning',
        notify_delivery_success:
          'Success, now you can fill in logistics information.',
        notify_outstock_success: 'Deliver successful',
        text_batchproduct_message_body:
          'Would you want to deliver these products? checked the infomation repeatedly because of this operation is irreversible!',
        text_sign_message_title: 'Message',
        text_sign_message_body:
          "Customer may not receive products, would you want to confirm this order? This order will be marked to 'completed'.",
        notify_sign_success: 'Confirm order successful',
        text_logistics_no: 'Tracking No.:',
        text_logistics_company: 'Carrier:',
        text_time: 'Time:',
        text_download: 'Download',
        text_remove: 'Remove',
        text_editlogistics_body:
          'Are you sure to save new logistics number? System will reload logistics infomation immediately!',
        notify_editlogistics_success: 'Logistics infomation will be reload.',
        title_tracking: 'Logistics tracking:',
        text_editdelivery_prompt_body: 'Select a delivery term',
        text_check_file_title: 'Files',
        text_select_org: 'Set organization',
        text_editdelivery_prompt_null: 'Delivery Term is required.',
        text_editdelivery_nomodify: 'No changes',
        label_select_termsa: 'Self Pick-up',
        label_select_termsb: 'Shipping by iFi Audio',
        label_sale_org: 'Sale organization',
        notify_editdelivery_success: 'Delivery Term is modified.',
        btn_gettracking: 'Post',
        text_track_tip: "Click 'Post' to get logistics information",
        notify_one_detail_least: 'One product required(at least).',
        text_remove_details:
          'Would you want to remove it? This operation is irreversible!',
        dialog_selectproducts: 'Select products',
        btn_iconfirmed: 'Got it.',
        text_modifyprice: 'A demo price for dealer that must to mofify.',
        notify_weighttotal_err: 'The total of weights failed to load.',
        notify_record_err: 'Log error.',
        title_pi: 'Profoma invoice',
        title_pt: 'Bank slip',
        title_pl: 'Packing list',
        title_ci: 'Commercial invoice',
        title_newfile: 'New file',
        label_select_filetype: 'Type',
        label_select_file: 'File',
        notify_upload_newfile: 'File and Type are required.',
        text_remove_file_body:
          'The file will not be recoverable after removing.',
        notify_orderline_pi: 'Create a profoma invoice at order flow first.',
        notify_orderline_pt: 'Create a bank slip at order flow first.',
        notify_orderline_pl: 'Create a packing list at order flow first.',
        notify_orderline_ci: 'Create a commercial invoice at order flow first.',
        notify_updatenotes: 'Notes updated!',
        notify_org_required: 'Organization is required.',
        notify_org_saved: 'Saved, please check up order.',
      },
      quickordering: {
        btn_quick_submit: 'Create order',
        label_customer: 'Customer',
        label_details: 'Products',
        title_p_adder: 'Add product',
        btn_addtoorder: 'Done',
        lebel_subweight: 'Subtotal(Weight)',
        text_order_done: 'Submit this order and send emails?',
        unfinished_order: 'Filling in all items.',
        switch_default_discount: 'Use default discount',
      },
      property: {
        tab_country: 'Region',
        tab_paymentterms: 'Payment terms',
        tab_orderstatus: 'Status',
        tag_forcerefresh: ' Notice: Click to synchronize before you update.',
        tag_paymenttype: ' Type = 1：Monthly，Type = 0：Not monthly',
        button_refresh: 'Synchronize',
        button_addrow: 'New',
        label_c_namecn: 'Name(Chinese)',
        label_c_nameen: 'Name(English)',
        label_gc_code: '3PL-Code',
        label_c_code: 'Code',
        label_os_priority: 'Priority',
        label_os_doingcn: 'Doing(Chinese)',
        label_os_doingen: 'Doing(English)',
        label_os_donecn: 'Done(Chinese)',
        label_os_doneen: 'Done(English)',
        label_pt_contentcn: 'Payment terms(English)',
        label_pt_contenten: 'Payment terms(Chinese)',
        label_pt_type: 'Monthly payment',
        label_options: 'Option',
        label_pt_currencyname: 'Name',
        label_pt_currencynameen: 'Name(English)',
        label_pt_currencysign: 'Symbol',
        label_pt_currencyabbr: 'Abbr.',
      },
      synproducts: {
        waitfork3: 'Waiting for K3...',
        tab_synproducts: 'Products',
        label_pd_sysname: 'BOM name',
        label_pd_name: 'Display name',
        label_pd_brand: 'Brand',
        label_pd_img: 'Image',
        label_pd_sign: 'Currency',
        label_pd_k3code: 'K3 Code',
        label_pd_saleprice: 'Price(International)',
        label_pd_saleprice_cn: 'Price(Domestic)',
        label_pd_weight: 'Unit weight',
        label_pd_rweight: 'Bulk Weight/Box',
        label_pd_g_sku: '3PL SKU',
        label_pd_sku: 'SKU',
        label_pd_ean: 'EAN/Barcode',
        label_pd_boxpcs: 'Bulk Quantity/box',
        master_pack: 'Master Pack Box Quantity',
        master_carton: 'Master Carton Box Quantity',
        label_pd_feature: 'Master Pack Size',
        mcsize: "Bulk Carton Size",
        label_pd_isshow: 'On sale(International)',
        label_pd_isshow_cn: 'On sale(Domestic)',
        // "label_pd_prices": "Prices(Euro Staged)",
        label_pd_prices: 'Price Setting',
        label_pd_blacklist: 'Blacklist',
        label_pd_description: 'Description',
        btn_pd_prices: 'Price(Currency)',
        btn_pd_prices_2: 'Price(Euro Staged)',
        staged_qty: 'Tiered Quantity',
        check_pd_newprice: 'Enable new price system',
        btn_pd_blacklist: 'Check block list',
        title_blacklist: 'Blacklist',
        alert_blacklist:
          'Imformation shared with international and domestic customers.',
        alert_blacklist_2:
          "Customer won't see this product if he/she is checked.",
        label_inter_cust: 'International customer',
        label_dome_cust: 'Domestic customer',
        btn_loadfromk3: 'Synchronize from K3',
        empty_products: "Click 'Synchronize' to update.",
        tooltip_sysname: 'Original name of product',
        tooltip_name: 'This name will be seen by customer',
        tooltip_saleprice: 'Set your price when product will be selling',
        tooltip_weight: 'A net weight of unit',
        tooltip_rweight: 'A gross weight of products in box',
        tooltip_g_sku: '3PL SKU',
        tooltip_sku: 'SKU',
        tooltip_ean: 'EAN/Barcode',
        tooltip_boxpcs: 'Quantity of products in box',
        tooltip_feature: 'Feature of box',
        tooltip_isshow: 'Switch this product on sale or out of sale',
        tooltip_description: 'Describe this product',
        button_doedit_product: 'Save',
        button_docancel_product: 'Cancel',
        button_batchsell: 'Batch',
        radio_product_all: 'All',
        radio_product_on: 'On sale',
        radio_product_off: 'Out of sale',
        message_batchsuccess: 'Success',
        span_upload_body1: 'Drag to here or',
        span_upload_body2: ' Click to upload',
        span_tip_upload: 'jpg/png only and 5MB limited',
        message_success: 'Saved',
        notify_connected_k3system:
          'Failed to connect k3 system, contact your administrator!',
        radio_rand_ifi: 'iFi',
        radio_rand_silentpower: 'Silent Power',
        master_pack_qty_tip:
          'This will override the Master Pack standard carton quantity field, please check the setting.',
        updateInfoByPMS: "Update Info"
      },
      pricingrules: {
        tab_ruleslist: 'Rules',
        tag_price_currency:
          ' USD is the default currency in rules, one rule will be enable in duplicate.',
        button_refresh: 'Synchronize',
        button_addrow: 'New',
        title_new_rules: 'Add rule',
        title_set_customer: 'Set customers',
        label_product: 'Product',
        label_price: 'Price(USD)',
        label_customers: 'Customers',
        text_remove_rule:
          'Would you want to remove this rule? This operation is irreversible!',
        notify_additems_null: 'All items are required.',
        notify_price_nochanges: 'New price must be different from default.',
      },
      discountrules: {
        label_discount: 'Discount(0-1%)',
        notify_discount_range: 'The discount on a scale ranging from 0 to 1.',
      },
      brand: {
        button_refresh: 'Refresh',
        button_add: 'Add',
        label_id: 'ID',
        label_name: 'Brand Name',
        label_brandCode: 'Brand Code',
        label_options: 'Options',
        notify_name_required: 'Brand name is required',
        notify_brandCode_required: 'Brand Code is required',
        text_confirm_delete: 'All customer brand discounts associated with this brand will be invalidated, and the product brand attribute will be cleared. This cannot be undone. Confirm delete?',
      },
      pricesystem: {
        button_refresh: 'Synchronize',
        button_add: 'Add',
        button_copy: 'Copy',
        button_export: 'Export',
        button_delete: 'Delete',
        title_add: 'Add Price System',
        title_edit: 'Edit Price System',
        title_copy: 'Copy Price System',
        label_id: 'ID',
        label_name: 'Master Pack Price System',
        label_currency: 'Currency',
        label_total_product: 'Bound Products Quantity',
        label_active_product: 'Active Products Quantity',
        label_status: 'Status',
        label_updated_by: 'Last Modified By',
        label_updated_time: 'Last Modified Time',
        label_options: 'Option',
        notify_required: 'Name and currency are required.',
        notify_name_exists: 'This price system name already exists.',
        notify_referenced: 'This price system is referenced by customers and cannot be deleted.',
        text_confirm_delete: 'Are you sure to delete this price system? This action is irreversible!',
      },
      pricesystemdetail: {
        title_add: 'Add Master Pack Price System',
        title_edit: 'Edit Master Pack Price System',
        title_detail: 'Master Pack Price System Detail',
        title_product_list: 'Product List',
        title_import: 'Import Products',
        button_add_product: 'Add Product',
        button_sync_product: 'Sync Products',
        button_import: 'Import',
        button_export: 'Export',
        button_select_file: 'Select File',
        phd_search_product: 'Product name / code',
        col_product_name: 'Product Name',
        col_product_code: 'Product Code',
        col_standard_pack_qty: 'Master Pack Std Qty',
        col_master_pack_size: 'Master Pack Size',
        col_single_unit_price: 'Single Unit Price',
        col_master_pack_price: 'Master Pack Price',
        col_master_pack_qty: 'Master Pack QTY',
        col_master_carton_price: 'Master Carton Price',
        col_master_carton_qty: 'Master Carton QTY',
        notify_row_incomplete: 'Please complete row ',
        notify_row_incomplete_suffix: ' data',
        notify_product_list_empty: 'Product list cannot be empty.',
        notify_select_file: 'Please select a file to import.',
        notify_save_first: 'Please save the price system first before exporting.',
        notify_no_products: 'The quantity of products is empty',
        span_upload_body1: 'Drag to here or',
        span_upload_body2: ' Click to upload',
        upload_tip_xlsx: 'Only .xlsx / .xls files are supported'
      },
      globalemail: {
        tab_globalemail: 'Global',
        tag_forcedelete: ' Just 1 way can be allowed to set on for each email.',
        tab_custom: 'Custom',
        label_email: 'Email',
        label_countries: 'Region',
        label_cust: 'Customer',
        label_exception_countries: 'Blacklist',
        button_refresh: 'Synchronize',
        button_addrow: 'New',
        label_options: 'Option',
        notify_one_email_least: 'One email required(at least).',
        title_new_global_email: 'Add global email',
        title_new_costom_email: 'Add custom email',
        notify_email_null: 'Email is required.',
        notify_country_null: 'Region is required.',
        content_email_repeatly: 'Email already exists.',
        title_setcountry: 'Set region',
        title_setblacklist: 'Blacklist',
        title_setcust: 'Set customer',
        text_remove_email:
          'Would you want to remove it? This operation is irreversible!',
        notify_changetype1:
          'You will save region and delete customer of email, continue?',
        notify_changetype2:
          'You will save customer and delete region of email, continue?',
        notify_least1_checked: 'Save with 1 item at the least.',
      },
      survey: {
        empty_explain: '  No result yet!',
      },
      '3pl': {
        tab_standardorder: 'Standardorder',
        button_querylocal: 'Download',
        button_synchrnize: 'Synchronize',
        button_updatefid: 'Refresh',
        no_notifyorder_update: 'Order is up to date.',
        notifyorder_update_1: ' ',
        notifyorder_update_2: ' new item(s) updated!',
        empty_order: "Click 'Synchronize' to update.",
        label_notifyorder: 'Notify order No.',
        label_order: 'Order No.',
        label_contacts: 'Contacts',
        label_g_w_code: 'Warehouse code',
        label_status: 'Status',
        label_option: 'Option',
        notify_rollback_k3_err1: 'Try it later because some orders is inuse.',
        status_0: 'Waiting for upload',
        status_1: 'Uploaded',
        status_2: 'Callbacked',
        status_3: 'Sorted',
        notify_outofstock: 'Some products are out of stock or not exsit!',
        text_upload_standard_sorder: 'Upload to 3PL',
        text_callbackinfo: 'Download from 3PL',
        text_savetok3: 'Save to K3',
        text_view_details: 'View details',
        notify_ordercode_insys: "(Don't close) Order code error: ",
        notify_callbackinfo_success:
          'Callback tracking number and serial number done.',
        notify_no_sn_update:
          'Tracking number and serial number are not updated.',
        notify_some_sns_notuptodate:
          'Contact your administrator because sns are not update.',
        notify_savek3_success: 'Saved to K3.',
        explain_status0:
          'Waiting for upload: This order is not upload to 3PL yet.',
        explain_status1: 'Uploaded: This order is saved with draft on 3PL.',
        explain_status2:
          'Callbacked: Tracking number and sns are saved to portal.',
        explain_status3: 'Sorted: Sns has been saved to K3.',
        label_details: 'Item details: ',
        label_quantity: 'Quantity',
      },
      aftersales: {
        tab_sntool: 'Serial number tool',
        text_sninput: "Please separate the SNs with '-'",
        button_searchsns: 'Start to search',
        text_loadingsearch: 'Too much data to handle. Please wait patiently.',
        text_repeat:
          'SN has more than one data, first data will be display below.',
        text_notfound: 'SNs have no data or were not out of stock.',
        text_error: 'SNs throw errors.',
        text_success: 'SNs and informations show in table below.',
        label_sn: 'Serial number',
        label_mfid: 'Material number',
        label_mname: 'Material name',
        label_customer: 'Customer',
        label_outstockno: 'Sales stock number',
        label_outstocktime: 'Out of stock time',
        label_orderno: 'Sales order number',
        label_duration: 'Duration',
        notify_inputsnerr: 'Adjust your text and try again.',
      },
      webstore: {
        label_contents: 'Webstore proccessing orders total: ',
        label_contents_s: 'Shopify proccessing orders total: ',
        btn_updateorder: 'Update',
        btn_getorder: 'Download',
        label_options: 'Options',
        label_status: 'Status',
        label_k3_id: 'K3 Order ID',
        label_wid: 'Webstore id',
        label_actual_order_id: 'Shopify Actual ID',
        label_sid: 'Shopify Order ID',
        label_currency: 'Currency',
        label_fullname: 'Fullname',
        label_shippingtotal: 'Shipping total',
        label_taxtotal: 'Tax total',
        label_discounttotal: 'Discount',
        label_total: 'Total',
        label_item: 'Item(s)',
        label_shipping: 'Shipping',
        label_billing: 'Billing',
        label_notes: 'Notes',
        title_setorderstatus: 'Status Update',
        notify_no_processingorder: 'No update, please download.',
        notify_no_fids: 'No local order exist, request for update...',
        notify_update_total: 'Updated: ',
        notify_no_localorder: 'No order. please update.',
        notify_np_localproduct: 'No any products, system error.',
        notify_no_portal_id:
          'Orders have been rejected caused due to incorrect infomations, there are: ',
        tip_checkup: 'Check up',
        tip_recall: 'Recall',
        tip_callback: 'Download trackings',
        tip_upload: 'Fulfill',
        notify_record_failed: 'Records error.',
        notify_status_failed: 'Update order status failed.',
        notify_save_repeatly: 'Do not save k3 order repeatly.',
        notify_worder_completed:
          'Tracking informations and status have been saved to Webstore.',
      },
    },
    page: {
      login: {
        dragtext: 'Drag the slider to right',
        dragtextsucc: 'Success',
        loadingviadingtalk: 'Waiting for dingtalk...',
        notify_dingtalk_not_bound:
          'You do not bind Dingtalk, open management page or contact your administrator please.',
      },
      home: {
        cart: 'Add to cart',
        tooltip_todetails: 'Click To Details',
        notify_series_outofsize:
          'Too many products in this series, add them manually please.',
        notice_demoprice_dealer: 'A demo price for distributor/dealer.',
        notice_goldbar: 'Order one GOld bar for every 10x Standard GO bar.',
      },
      details: {
        price: 'Price/pcs:',
        quantity: 'Quantity:',
        pageheader_title: 'Back',
        pageheader_details: 'Details',
        label_weight: 'Unit weight： ',
        label_rweight: 'Weight/Box： ',
        label_sku: 'SKU No.： ',
        label_ean: 'EAN/Barcode： ',
        label_boxpcs: 'Quantity/Box： ',
        label_feature: 'Feature of package(box)： ',
        label_description: 'Description：',
      },
      cart: {
        head_title: 'Shopping Cart',
        empty_cart: 'Oops! Nothing here.',
        empty_cart_url: 'Go shopping',
        text_total: 'Total:',
        text_weight: 'Weight:',
        btn_clearcart: 'Clear',
        btn_checkout: 'Checkout',
        tooltip_refresh_cart: 'Refresh',
        productimage: 'Image',
        productname: 'Name',
        productprice: 'Retail Price',
        productdiscount: 'Discount(%)',
        productdisprice: 'Discounted price',
        ladderPrice: 'Special Offer',
        ladderRange: 'Tiered Price',
        productquantity: 'Quantity',
        productsubprice: 'Subtotal',
        productoption: 'Option',
        text_clearcartconfirm_body: 'Are you sure to clear?',
        text_clearcartconfirm_title: 'Message',
        btn_clearcart_confirm: 'Clear',
        btn_clearcart_cancel: 'Cancel',
        message_clearcart_delete: 'Success',
        message_clearcart_cancel: 'Canceled',
        tag_modifyquantity: "Cilck '√' to change quantity.",
        label_least_total: 'Minimum order amount ：',
        label_least_weight: 'The minimum of weight:',
        air_alert:
          'ZEN Air Series 30pcs export sales only in Master Packs, Please place your order in multiples of 30pcs.',
      },
      orderconfirm: {
        notice_modifyadd:
          'Go to personal center(at the top right) to edit your addresses.',
        address_title: 'Shipping',
        receipt_title: 'Proforma invoice',
        delivery_title: 'Delivery Term',
        payment_title: 'Payment Term',
        details_title: 'Details',
        address_add: 'Use another one',
        title_country: 'Region',
        title_province: 'Province/State',
        title_city: 'City',
        title_zipcode: 'Zipcode',
        title_detailadd: 'Address',
        title_contacts: 'Contact',
        title_company: 'Company',
        title_tel: 'Tel.',
        title_email: 'Email',
        title_tag: 'Tag',
        title_taxno: 'VAT NO.',
        btn_newadd: 'Save',
        text_no_address: 'Oops! You have no address yet.',
        radio_delivery_a: 'Self Pick-up',
        radio_delivery_b: 'Shipping by iFi Audio',
        notify_delivery_a: 'Booking to take your goods away from factory.',
        notify_delivery_b: 'Goods wiil be shipped from factory.',
        title_customer_po: 'Customer Order No.：',
        title_notes: 'Notes：',
        btn_submit: 'Place Order',
        tooltip_mintotal_weight:
          'This button is disabled caused by the minimum amount or the minimum weight is not enough.',
        notify_check_shippingaddress: 'Please pick a shipping address.',
        notify_check_receiptaddress: 'Please pick an invoice address.',
        notify_check_deliveryterms: 'Please pick a delivery term.',
        notify_check_details: 'Nothing in order form, unable to submit',
        notify_check_mintotal_minweight:
          'The minimum total or the minimum weight is not enough.',
        notify_product_outofselling:
          'A product was out of selling, please cofirm it.',
        notify_normal_err_code: 'Error code: -1',
        notify_email_error: 'The email is not available.',
        notify_warn: 'Warning',
        notify_full_address_java:
          "Ten addresses per user! Don't add it illegally!",
        notify_pricemodified:
          'The prices of the following items in your shopping cart have been updated, or the items are no longer available. Please refresh the page or remove the items and add them again.',
        notify_email_exception:
          "Email service throws an exception, maybe you won't receive email of order.",
        quantity_unupdate_error:
          'Total number of items is incorrect. Please check or refresh.',
        copyToInvoice_notice:
          'Make sure your invoice addresses are less than 10 before copying, continue?',
        title_feedback: 'Customer Satisfaction Survey',
        tip_feedback:
          'So that we can provide you with the best possible service, please give us your feedback.',
        why: 'Why',
        question_unfinished: 'Unfinished question: No.',
        notify_feedback_success: 'Thanks for your feedback!',
      },
      orderform: {
        notice_tips0:
          'You can track your order in personal center at any time(at the top right).',
        ordersstatus_title: 'Status',
        shipping_title: 'Shipping',
        receipt_title: 'Proforma invoice',
        payment_title: 'Payment infomation',
        other_title: 'Shipping documents',
        details_title: 'Details',
        list_title: 'List',
        shipping_contacts: 'Contact:',
        shipping_address: 'Address:',
        shipping_country: 'Region:',
        shipping_province: 'Province/State:',
        shipping_city: 'City:',
        shipping_zipcode: 'Zipcode:',
        shipping_tel: 'Tel.:',
        shipping_email: 'Email:',
        span_current_body0: 'Customer Order No.:',
        span_current_body1: 'Order No.:',
        span_current_body2: ', Status:',
        span_time_zone: 'Time zone:',
        span_total: 'Total:',
        span_totalWeight: 'Weight:',
        span_no_receiptimg: 'No proforma invoice yet.',
        span_no_packinglist: 'No packing list yet.',
        span_no_commercialinvoice: 'No commercial invoice yet.',
        span_paymentupload_body1: 'Drag to here or',
        span_paymentupload_body2: ' Click to upload',
        span_tip_upload: 'jpg/png only and 5MB limited',
        span_img_packinglist: 'Packing list',
        span_img_cominvoice: 'Commercial invoice',
        notify_upload_success: 'Upload successful',
        tag_notice_skip_payment: ' Contact us to skip this step.',
        tag_notice_payment:
          ' Order will be updated when the bank slip have been checked.',
        tag_notice_modifydetails:
          ' The notes can be modified any times before delivery, but last one will be confirmed.',
        btn_done: 'Done',
        notify_notessuccess: 'We already received your notes.',
        tag_pickupself:
          ' If you pick up goods by yousrelf, no tracking information will be updated.',
        btn_sign: 'Confirm',
        span_ordercompleted: 'This order is completed.',
        notify_confirmorder_success: 'Confirm successful',
        notify_repeat_confirm: "Don't confirm it repeatedly",
        text_logistics_no: 'Tracking No.:',
        text_time: 'Time:',
        title_batchtable: 'Delivery list',
        title_tracking: 'Logistics tracking',
        btn_postapi: 'Post',
        text_track_tip: "Click 'Post' to get logistics information",
        tag_ad_notice:
          ' Advertisement in tracking box is provided by third party.',
      },
      center: {
        tab_info: 'Basic information',
        tab_order: 'My order',
        tab_shipping: 'My Shipping address',
        tab_receipt: 'My Proforma invoice address',
        label_order_number: 'Entity:',
        label_order_fid: 'Order No.:',
        label_order_custpo: 'Customer PO NO.:',
        label_order_createtime: 'Created time:',
        radio_orderlist_all: 'All',
        radio_orderlist_processing: 'To be determined',
        radio_orderlist_finished: 'Completed',
        btn_message_confirm: 'Confirm',
        btn_message_cancel: 'No, cancel',
        text_delete_message_body: 'Would you want to delete it?',
        text_delete_message_title: 'Please confirm',
        delete_address_success: 'Deleted',
        empty_address: "Nothing here ~~ Click ' Add ' to create one",
        btn_add: 'Add',
        notify_title_notification: 'Notification',
        notify_full_address: 'Ten addresses per user',
        notify_normal_err_code: 'Error code: -1',
        notify_address_null: 'Information Incomplete.',
        notify_email_error: 'The email is not available',
        message_success: 'Saved',
        message_resetpasssuccess:
          'Reset success, redirect to login in 3 seconds.',
        notify_warn: 'Warning',
        notify_full_address_java:
          "Ten addresses per user! Don't add it illegally!",
        message_cancel: 'Canceled',
        btn_resetpassword: 'Reset Password',
        title_reset_password: 'Reset Password',
        label_newpass: 'New password',
        btn_save: 'Save',
        tooltip_email: 'Set email for pushing notification',
        notify_nochange: 'No changes',
        notify_password_length: 'Password must be between 3,15 characters',
        label_ccemail: 'Assistance email',
        alert_ccemail:
          ' Assistance emails(up to 5) are used for receiving an email that includes order details.',
        notify_all_synced: "All products have been successfully synchronized"
      },
      console: {
        tip_refresh: 'Update releases',
        router_information: 'My information',
        router_settings: 'Setting',
        router_logout: 'Logout',
        menuitem_user: '— User —',
        menuitem_order: '— Portal —',
        menuitem_webstore: '— eCommerce —',
        menuitem_product: '— Product —',
        menuitem_3pl: '— Third-party logistics —',
        menuitem_properties: '— Property —',
        menuitem_feedback: '— Feedback —',
        menuitem_settings: '— Setting —',
        menuitem_aftersales: '— Tools —',
        menuitem_data: '— Data —',
        dataplatform: '—— Data Platform ——',
        shopify: 'Order Management',
        childmenuitem_controluser: 'Control user',
        childmenuitem_customer: 'Intl customer',
        childmenuitem_domesticcustomer: 'Chinese customer',
        childmenuitem_orderlists: 'Intl order',
        childmenuitem_domesticorder: 'Chinese order',
        childmenuitem_quickorder: 'Quick ordering',
        childmenuitem_order: 'iFi Webstore',
        childmenuitem_order1: 'iFi Shopify',
        childmenuitem_globalemail: 'Email notification',
        childmenuitem_synproducts: 'Sync&setting',
        childmenuitem_pricingrules: 'Pricing rule',
        childmenuitem_discountrules: 'Discount rule',
        childmenuitem_pricesystem: 'Master Pack Price Config',
        childmenuitem_country: 'Region',
        childmenuitem_currency: 'Currency',
        childmenuitem_exchangerate: 'Exchange rate',
        childmenuitem_unit: 'Unit',
        childmenuitem_paymentterms: 'Payment',
        childmenuitem_ordertatus: 'Status',
        childmenuitem_brand: 'Brand',
        childmenuitem_satisfacation: 'Satisfacation survey',
        childmenuitem_general: 'General',
        childmenuitem_permissions: 'Permission',
        childmenuitem_sn: 'Serial number tool',
        childmenuitem_statistics: 'Statistics',
        childmenuitem_analysis: 'Analysis',
        childmenuitem_bigdata: 'Big Data',
        childmenuitem_g_standardorder: 'Standard order',
        childmenuitem_g_platformorder: 'eCommerce order',
        topexplain: 'Use left bar to start.',
      },
    },
    ordermanage: {
      order: 'Order ',
      query: 'Query',
      list: 'List',
      number: 'ID',
      type: 'Type',
      status: 'Status',
      reset: 'Reset',
      status1: 'Pending push',
      status2: 'Pushed',
      status3: 'Shipped',
      status4: 'Cancelled',
      update: 'Update Status',
      country: 'Country',
      currency: 'Currency',
      qty: 'Quantity',
      total: 'Total Cost',
      logistics: 'Logistics',
      source: 'Order Source',
      detail: 'Order Details',
      abnormal: 'Abnormal ',
      info: 'Info',
      sourcedata: 'Source Data',
      customer: 'Customer',
      organization: 'Shipping Organization',
      province: 'province/state/address',
      city: 'City',
      contactPerson: 'Contact Person',
      postCode: 'Postal Code',
      address: 'Address',
      other: 'Other',
      basicInfo: 'Basic Information',
      detail: 'Details',
      materialCode: 'Material Code',
      materialName: 'Material Name',
      specifications: 'Specifications',
      bomVersion: 'BOM Version',
      inventoryOrganization: 'Inventory Organization',
      warehouse: 'Warehouse',
      unitPrice: 'Unit Price(including tax)',
      totalAmount: 'Total Amount',
      discount: 'Discount',
      tax: "Tax",
      shippding: "Shipping",
      view: 'View',
      pending: "Pending processing (initial status)",
      created: "Sales order created (not submitted)",
      submitted: "Sales order submitted (pending review)",
      audited: "Sales order reviewed (pending delivery notification)",
      created1: "Delivery notification created",
      filled: "Logistics information filled (delivery notification pending submission)",
      submitted1: "Delivery notification submitted (pending review)",
      audited1: "Delivery notification reviewed (pending sales outbound order)",
      created2: "Sales outbound order created (snatch SN filled)",
      snfilled: "Sales outbound order SN filled (pending submission)",
      submitted2: "Sales outbound order submitted(pending review)",
      audited2: "Sales outbound order reviewed (automatic accounts receivable successfully pushed down)",
      k3generated: "K3 accounts receivable generation completed (process ended)",
      Processing: "Processing",
      Completed: "Completed",
      Cancel: "Failure",
      detail: "Detail",
      code: "Code",
      createtime: "Create Time",
      cancleTip: "Should this order be marked as invalid? Once invalidated, it cannot be restored.",
      pushToK3: "Manually push this order to K3. Manual pushing does not check inventory. Please check if the inventory is sufficient.",
      updateTip: "Restart the automated scheduled task",
      platformStatus: "Status",
      pstatus1: "Pending",
      pstatus2: "Performed",
      notes: "Notes",
      transport: "Transport",
      jingdong: "JD ",
      jindongTip: "Confirm whether to enable/disable JD Logistics?",
      jingdongPush: "JD Push",
      returnGoods: "Partial returns",
      jd: "JD",
      barn: "Barn",
      cancleReason: "Reason for cancellation",
      jindongPushTip: "The program has been executed; please wait 2 minutes."
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js